import TRTC from 'trtc-js-sdk'

TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.NONE)

export default class {
  /**
   * client 实例
   */
  client = null

  /**
   * 本地 stream 实例
   */
  localStream = null

  /**
   * 远端 stream 实例
   */
  remoteStream = null

  /**
   * 是否支持WebRTC
   */
  support = null

  /**
   * 是否拥有camera
   */
  camera = null

  /**
   * 订阅是否成功
  */
  subscribed = null

  /**
   * 检测是否支持WebRTC
   */
  detectRTC() {
    return new Promise(resolve => {
      TRTC.checkSystemRequirements().then((result) => {
        if (!result.result) {
          this.support = false
          resolve(false)
        } else {
          this.support = true
          resolve(true)
        }
      }).catch(() => {
        resolve(false)
      })
    })
  }

  /**
   * 创建 CLient 对象
   */
  createClient({ userId, userSig }) {
    const options = {
      enableAutoPlayDialog: false,
      mode: 'rtc',
      sdkAppId: parseInt(process.env.VUE_APP_SDK_APP_ID),
      userId,
      userSig
    }
    this.client = TRTC.createClient(options)
    return this.client
  }

  /**
   * 监听事件
   */
  on(name, callback) {
    this.client.on(name, callback)
  }

  /**
   * 获取本地视频流
   */
  getLocalStream({ userId }) {
    return new Promise((resolve, reject) => {
      const localStream = TRTC.createStream({ userId, audio: true, video: true })
      localStream.initialize().then(() => {
        this.camera = true
        this.localStream = localStream
        resolve(localStream)
      }).catch(err => {
        this.camera = false
        reject(err)
      })
    })
  }

  /**
   * 获取本地音频流
   */
  getAudioLocalStream({ userId }) {
    return new Promise((resolve, reject) => {
      const localStream = TRTC.createStream({ userId, audio: true, video: false })
      localStream.initialize().then(() => {

        // this.client.publish(localStream).then(() => {
        //   console.log('local stream published');
        // });
        resolve(localStream)
      }).catch(err => {
        resolve(false)
      })
    })
  }

  /**
   *  发布本地视频流
   */
  publishLocalStream(localStream) {
    return new Promise((resolve, reject) => {
      this.client.publish(localStream).then(() => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 进入房间
   */
  joinRoom({ roomId }) {
    return new Promise((resolve, reject) => {
      this.client.join({ roomId }).then(() => {
        resolve({ type: true })
      }).catch(err => {
        resolve({ type: false, message: err })
      })
    })
  }

  /**
   * 订阅视频流
   */
  subscribe(stream) {
    this.client.subscribe(stream)
  }

  /**
   * 退出房间
   */
  leaveRoom() {
    return new Promise((resolve, reject) => {
      console.log(this.localStream)
      if (this.localStream !== null) {
        // // 关闭视频通话示例，对应addTrack接口的开启视频通话示例
        // const videoTrack = this.localStream.getVideoTrack()
        // if (videoTrack) {
        //     this.localStream.removeTrack(videoTrack).then(() => {
        //         // 关闭视频通话成功，停止videoTrack并释放摄像头资源
        //         console.log('remove video call success');
        //         videoTrack.stop();
        //     })
        // }
        this.client.unpublish(this.localStream).then(res => {
          this.localStream.close()
          this.client.leave().then(() => {
            resolve()
          }).catch(err => {
            reject(err)
          })
        }).catch((err) => {
          reject(err)
          console.log('error', 'unpublish error：' + err);
        })
      } else {
        this.client.leave().then(() => {
          resolve()
        }).catch(err => {
          reject(err)
        })
      }

    })
  }

  /**
   * 开启音频
   */
  muteAudio() {
    this.localStream.muteAudio()
  }

  /**
   * 关闭音频
   */
  unmuteAudio() {
    this.localStream.unmuteAudio()
  }

  /**
   * 开启视频
   */
  muteVideo() {
    this.localStream.muteVideo()
  }

  /**
   * 关闭视频
   */
  unmuteVideo() {
    this.localStream.unmuteVideo()
  }
}
